export default __webpack_public_path__ + "static/media/PTSerif-Regular.6271ca9b.ttf";